import React from 'react';
import { graphql } from 'gatsby';
import Container from '@atoms/Container';
import ArticleCard from '@sections/ArticleCard';
import paddingDefault from '@utils/paddingDefault';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import { colors } from '../primitives/colors';

const MultiBlogroll = ({ data }) => {
  const { subblog: subblogs } = data;

  return (
    <section css={paddingDefault()}>
      <Container css={styles.container}>
        {!!subblogs &&
          subblogs.map((subroll, i) => {
            const { articles } = subroll.articles[0] || []
            const { title } = subroll.articles[0]
            const isFull = articles.length === 4

            return (
              <div css={styles.blogrollGridWrapper(isFull)} key={i}>
                {title && (
                  <h2 css={styles.blogrollHeading}>
                    {apCaseOnlyTitleTags(title)}
                  </h2>
                )}
                <ul css={styles.blogrollGrid(isFull)}>
                  {articles.map(article => (
                    <li css={styles.blogrollGridItem} key={article.title}>
                      <ArticleCard article={article} />
                    </li>
                  ))}
                </ul>
              </div>
            )
          })}
      </Container>
    </section>
  )
}

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  blogrollHeading: {
    color: colors.primaryOrange,
    borderColor: colors.primaryOrange,
    paddingBottom: "0.5rem",
    paddingTop: "1rem",
    marginBottom: "0.5rem",
    borderBottomWidth: "1px",
    fontSize: "1.125rem",
    lineHeight: "1.75rem",
    fontWeight: 500,
    "@media (min-width: 1024px)": {
      marginBottom: "2.5rem",
      fontSize: "1.5rem",
      lineHeight: "2rem"
    }
  },
  blogrollGridWrapper: (isFull) => ({
    marginBottom: "0.5rem",
    width: "100%",
    "@media (min-width: 1024px)": {
      marginBottom: "2.5rem",
      width: isFull ? "100%" : "49%"
    }
  }),
  blogrollGrid: (isFull) => ({
    display: "grid",
    paddingTop: "1rem",
    paddingBottom: "2.5rem",
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    gap: "1.5rem",
    "@media (min-width: 768px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      rowGap: "4rem"
    },
    "@media (min-width: 1024px)": {
      gridTemplateColumns: isFull && "repeat(4, minmax(0, 1fr))"
    }
  }),
  blogrollGridItem: {
    flex: "1 1 auto",
    width: "100%"
  }
};

export const query = graphql`
  fragment MultiBlogrollData on CmsPageBuilderBlocks {
    multi_blogroll {
      subblog {
        heading
        articles {
          title
          articles {
            featured_image {
              filename
              title
              description
              url
              contentStackAsset(width: 1440)
            }
            title
            content
            url
          }
        }
      }
    }
  }
`;

export default MultiBlogroll;
